import { Icon } from '@ps/isp-web-component-library';
import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import { Link, Translation } from '@ps/web-shared-components';
import React, { useMemo } from 'react';

import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import type {
  DynamicBannerTemplate,
  ImageFetchProps,
  MarketDynamicBanner
} from '../../../model/types';
import BannerImage from '../../BannerImage/BannerImage';

import { TXTWCL_In_Play } from './MarketBanner.messages.json';
import styles from './MarketBanner.scss';
import EventName from './components/EventName';
import OddsBoostDynamicBannerContent from './templates/Oddsboost';
import RequestABetDynamicBannerContent from './templates/RequestABet';
import StandardMarketDynamicBannerContent from './templates/Standard';

type MarketDynamicBannerTemplate = Extract<
  DynamicBannerTemplate,
  'STANDARD' | 'ODDS_BOOST' | 'REQUEST_A_BET'
>;

const bannerComponents: Record<MarketDynamicBannerTemplate, React.FC<MarketDynamicBanner>> = {
  ODDS_BOOST: OddsBoostDynamicBannerContent,
  REQUEST_A_BET: RequestABetDynamicBannerContent,
  STANDARD: StandardMarketDynamicBannerContent
};

const MarketBanner: React.FC<MarketDynamicBanner & ImageFetchProps> = (props) => {
  const {
    image,
    template,
    eventType,
    competition,
    event,
    market: { marketLevels, inPlay },
    priority
  } = props;
  const BannerContentComponent = useMemo(
    () => (template !== 'BET_BUILDER' ? bannerComponents[template] : null),
    [template]
  );

  if (!BannerContentComponent) return null;

  const linkAlias =
    marketLevels && marketLevels[0] === 'AVB_EVENT' ? 'sportsEvent' : 'sportsCompetitionOutrights';

  return (
    <div className={styles.container}>
      <BannerImage image={image} priority={priority} />
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <Link
            alias={linkAlias}
            values={{ ...eventType, ...competition, ...event }}
            className={styles.link}
          >
            <div className={styles.eventStatus}>
              <div className={styles.time}>
                <Icon icon={InPlay} size="sm" data-testid="sports-icon" />
                {inPlay ? (
                  <Translation {...TXTWCL_In_Play} />
                ) : (
                  <FormattedDateTime date={event.eventStartTime} format="short" />
                )}
              </div>
            </div>
            <EventName eventName={event.eventName} />
          </Link>
          <BannerContentComponent {...props} />
        </div>
      </div>
    </div>
  );
};

export default MarketBanner;
